
































import { Component, Vue, Watch, Model, BasePage } from "@/common";
import { TwTable } from "@/components";
@Component({})
export default class ItemFetch extends BasePage {
  @Model("change", { type: Boolean })
  private value!: boolean;

  @Watch("value")
  onValueChange(val) {
    this.showEdit = val;
  }

  seqNos=[]

  @Watch("showEdit")
  onshowEditChange(val) {
    this.$emit("change", this.showEdit);
    if(val===true){
      this.$http.get("/Bill/GetBillSeqNo").then(res=>{
        this.seqNos.splice(0);
        this.seqNos.push(...res.data.data)
      });
    }else{
      this.searchMode.selectSeqNo.splice(0);
    }
  }

  saveMask = false;

 

  searchMode = {
     selectSeqNo:[]
  };

  showEdit = false;

  subbill() {
    this.$emit("on-ok",this.searchMode.selectSeqNo);
  }

  mounted() {
    this.showEdit = this.value;
  }
}
